import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';
import PubSub from 'pubsub-js';
import MediaQuery from 'react-responsive';

const screenWidth = window.screen.width;

class Screener extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterCriteria: {},
            reload: false,
            isDataLoading: false
        };
        this.limit = 500;
        this.screenerTrigger();
    }

    screenerTrigger(){
        this.screenerTrigger = PubSub.subscribe('screenSearch', (topic, crit) => {
            console.log('Stock Screener Triggered', crit);
            //this.setState({ filterCriteria: data, reload: true });
            this.getScreenedStocks(crit, this.limit);
        });
    }

    custom_sort(a, b) {
        if (a.symbol < b.symbol) { return -1; }
        if (a.symbol > b.symbol) { return 1; }
        return 0;
    }

    componentDidMount() {
        console.log('screenWidth', screenWidth);        
        console.log('screner this.props', this.props);
        if (this.props === undefined || Object.keys(this.props).length === 0) {
            this.getScreenedStocks(undefined, this.limit);
        }
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.screenerTrigger);
    }

    getScreenedStocks(crit, limit) {
        this.setState({ isDataLoading: true });
        ApiService.getStockScreener(crit, limit)
            .then(result => {
                console.log('Screener List', result);
                result = result.sort(this.custom_sort);
                this.setState({ list: result, isDataLoading: false });
                window.scrollTo(0, 0);
            })
            .catch((error) => {
                console.log(error);
            });

    }

    renderRow(listValue) {
        let url = '/chart/' + listValue.symbol;
        return (
            <tr key={listValue.symbol + listValue.marketCap}>
                <td><Link to={url}>{listValue.symbol}</Link></td>
                <MediaQuery minWidth={500}>
                    <td>{listValue.companyName}</td>
                    <td>{listValue.country}</td>
                    <td>{listValue.sector}</td>
                </MediaQuery>
                <MediaQuery minWidth={850}>
                    <td>{listValue.industry}</td>
                    <td>{listValue.exchangeShortName}</td>
                </MediaQuery>
                <td>{listValue.marketCap}</td>
                <td>{parseFloat(listValue.price).toFixed(2)}</td>
                <td>{parseFloat(listValue.volume).toFixed(0)}</td>
                <MediaQuery minWidth={500}>
                    <td>{parseFloat(listValue.lastAnnualDividend).toFixed(2)}</td>
                    <td>{parseFloat(listValue.beta).toFixed(2)}</td>
                </MediaQuery>
            </tr>
        )
    }

    render() {
        let tableRow;
        if (this.state.isDataLoading) {
            tableRow = <tr><td></td><td>Loading...</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
        } else if (this.state.list === undefined || this.state.list.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
        } else {
            tableRow = this.state.list.map(this.renderRow.bind(this));
        }
        return (
            <div>
                <Table striped bordered hover size="xs" style={{ fontSize: "10px" }}>
                    <thead>
                        <tr>
                            <th>Ticker</th>
                            <MediaQuery minWidth={500}>
                                <th>Company Name</th>
                                <th>Country</th>
                                <th>Sector</th>
                            </MediaQuery>
                            <MediaQuery minWidth={850}>
                                <th>Industry</th>
                                <th>Exchange</th>
                            </MediaQuery>
                            <th>Market Cap</th>
                            <th>Price($)</th>
                            <th>Volume</th>
                            <MediaQuery minWidth={500}>
                                <th>Dividend(%)</th>
                                <th>Beta</th>
                            </MediaQuery>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default Screener;
